<template></template>

<script>
import { DateTime } from "luxon";
import axios from "axios";

export default {
  props: {
    date: { type: String, required: true },
  },
  data() {
    return {
      data: null,
      extractData: [],
      loading: false,
      total: 0,
      valueFirstPeriod: 0,
      valueSecondPeriod: 0,
      tableData: [],
      loadingLiquidation: false,
      loadingTable: false,
      loadingExtract: false,
    };
  },
  watch: {
    date: {
      handler(newDate) {
        if (newDate) {
          this.fetchData(newDate);
          this.fetchTableData(newDate);
          this.fetchExtractData(newDate);
        }
      },
    },
  },
  methods: {
    async fetchData(date) {
      this.loadingLiquidation = true;
      this.$emit("update:loadingLiquidation", true);

      const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
      const API_KEY = process.env.VUE_APP_API_KEY_THOTH;
      const formattedDate = DateTime.fromISO(date).toFormat("yyyy-MM-dd");

      const response = await axios.get(
        `${BASE_URL}settlement-reconciliation/liquidation`,
        {
          params: { date: formattedDate },
          headers: { "Api-Key": API_KEY },
        }
      );

      this.data = response.data[0].data;
      this.total = response.data[0].total;
      this.valueFirstPeriod = response.data[0].valueFirstPeriod;
      this.valueSecondPeriod = response.data[0].valueSecondPeriod;

      this.$emit("loaded", this.data);
      this.$emit("load", {
        total: this.total,
        valueFirstPeriod: this.valueFirstPeriod,
        valueSecondPeriod: this.valueSecondPeriod,
      });

      this.loadingLiquidation = false;
      this.$emit("update:loadingLiquidation", false);
    },

    async fetchTableData(date) {
      this.loadingTable = true;
      this.$emit("update:loadingTable", true);

      const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
      const API_KEY = process.env.VUE_APP_API_KEY_THOTH;
      const formattedDate = DateTime.fromISO(date).toFormat("yyyy-MM-dd");

      const responseTables = await axios.get(
        `${BASE_URL}settlement-reconciliation`,
        {
          params: { date: formattedDate },
          headers: { "Api-Key": API_KEY },
        }
      );

      this.tableData = responseTables.data;
      
      this.$emit("tableDataLoaded", this.tableData);

      this.loadingTable = false;
      this.$emit("update:loadingTable", false);
    },

    async fetchExtractData(date) {
      this.loadingExtract = true;
      this.$emit("update:loadingExtract", true);

      const BASE_URL = process.env.VUE_APP_BASE_URL_THOTH;
      const API_KEY = process.env.VUE_APP_API_KEY_THOTH;
      const formattedDate = DateTime.fromISO(date).toFormat("yyyy-MM-dd");

      const responseExtract = await axios.get(
        `${BASE_URL}settlement-reconciliation/extract`,
        {
          params: { date: formattedDate },
          headers: { "Api-Key": API_KEY },
        }
      );

      this.extractData = responseExtract.data;
      this.$emit("tableExtractLoaded", this.extractData);

      this.loadingExtract = false;
      this.$emit("update:loadingExtract", false);
    },
  },
};
</script>
